export default __webpack_public_path__ + "static/media/marble-popup-sqm-img.9ae1d06c.jpg";